import React from 'react'

import { getTicket, capitalizeString } from '../../utilities/helpers'

import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'

import TicketRow from './TicketRow'
import './orderSummaryView.scss'

// Read-only order summary for payment listings and similar views.
export default function OrderSummaryView({ timezone, order }) {
  const totalTickets =
    order?.groupedByEvent?.length > 0
      ? order.groupedByEvent.reduce(
          (sum, group) => sum + (group.tickets?.length || 0),
          0
        )
      : order?.tickets?.length || 0

  const vouchers = order?.vouchers || []
  const hasVouchers = vouchers.length > 0
  const hasTickets = totalTickets > 0 || order?.groupedByEvent?.length > 0

  return (
    <div className="order-summary-view p-0 mb-0 border-0">
      <div id="order-summary-text">
        {hasVouchers && (
          <div className={hasTickets ? 'mb-4' : undefined}>
            <h5 className="mb-0 fw-bold">
              {order?.flex_pack?.name || 'Flex Pack'}
            </h5>
            <p className="mb-2 text-muted">
              {vouchers.length} voucher{vouchers.length !== 1 ? 's' : ''}
            </p>
            <div className="table-container border">
              <Table className="mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="text-left">Voucher Code</th>
                    <th className="text-left">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {vouchers.map((voucher, i) => (
                    <tr key={voucher?.id || voucher?.code || i}>
                      <td className="text-left">{voucher?.code}</td>
                      <td className="text-left">
                        <Badge
                          bg="none"
                          className={`badge--${
                            voucher?.claimed ? 'redeemed' : 'active'
                          }`}
                        >
                          {capitalizeString(
                            voucher?.claimed ? 'redeemed' : 'active'
                          )}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}

        {order?.groupedByEvent?.length > 0 ? (
          <div>
            {[...order.groupedByEvent]
              .sort(
                (a, b) => new Date(a.event?.start) - new Date(b.event?.start)
              )
              .map((group, idx) => (
                <div key={idx} className="mb-4">
                  <h5 className="mb-0 fw-bold">
                    {group.event?.name}
                    {group.event?.venue?.name && ` - ${group.event.venue.name}`}
                  </h5>
                  <p className="mb-2 text-muted">
                    {group.tickets?.length || 0} ticket
                    {(group.tickets?.length || 0) !== 1 ? 's' : ''}
                  </p>
                  <div className="table-container border">
                    <Table className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="text-left">Section</th>
                          <th className="text-left">Row</th>
                          <th className="text-left">Seat</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.tickets.map((ticket, i) => (
                          <TicketRow key={i} ticket={ticket} />
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              ))}
          </div>
        ) : hasTickets || !hasVouchers ? (
          <div>
            <div>
              {order?.event && (
                <>
                  <h5 className="mb-0 fw-bold">
                    {order.event.name}
                    {order.event.venue?.name && ` - ${order.event.venue.name}`}
                  </h5>
                </>
              )}
              <p className="mb-2 text-muted">
                {totalTickets} ticket{totalTickets !== 1 ? 's' : ''}
              </p>
            </div>
            <div className="table-container border">
              <Table className="mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="text-left">Section</th>
                    <th className="text-left">Row</th>
                    <th className="text-left">Seat</th>
                  </tr>
                </thead>
                <tbody>
                  {getTicket(order) &&
                    [...Array(totalTickets)].map((x, i) => {
                      return <TicketRow key={i} ticket={getTicket(order)[i]} />
                    })}
                </tbody>
              </Table>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
